/* stylelint-disable */
import { css, SerializedStyles } from '@emotion/react';

export const freshChatStyle = (isCasino: boolean): SerializedStyles => css`
    #fc_frame.fc-launcher-text,
    #fc_frame.fc-widget-small.fc-launcher-text,
    iframe#launcher-frame,
    iframe[title='Freshworks Widget'] {
        bottom: ${isCasino ? '50px !important' : '90px !important'};
        right: 2px !important;
        z-index: 1 !important;
        @media(min-width: 1024px){
            bottom: 20px !important;
            right: 15px !important;
            z-index: 11 !important;
        }
    }

    iframe#launcher-frame {
        height: 48px !important;
        max-height: 48px !important;
        max-width: 112px !important;
        min-height: 0 !important;
        min-width: 0 !important;
        width: 112px !important;
    }
`;
